export const userRecordStatus = [
  { key: "O", badgeColor: "badge-soft-success" },
  { key: "C", badgeColor: "badge-soft-danger" },
];

export const userRecordStatusMode = {
  ACTIVE: "O",
  INACTIVE: "C",
};

export const userModeList = {
  VIEW_USER_DETAIL: "VIEW_USER_DETAIL",
  EDIT_USER_DETAIL: "EDIT_USER_DETAIL",
};

export const emailPrefix = "@fecredit.com.vn";